export default __webpack_public_path__ + "static/media/syakai.b665a914.jpg";